<template>
  <section class="hero">
    <div class="hero-content">
      <div class="hero-left">
        <h1><span v-html="$t('hero.title2').replace(/\n/g, '<br>')"></span></h1>
        <p class="sub">{{ $t('hero.sub') }}</p>
        <button class="btn-start" @click="$router.push('/assessment')">{{ $t('hero.start') }} <img src="../assets/arrow-white@2x.png" style="width: 20px; height: auto;"></button>
      </div>
<!--      <div class="hero-right">-->
<!--        <div class="avatar-wrapper">-->
<!--          <div class="avatar">-->
<!--            <div class="avatar-placeholder">👩</div>-->
<!--          </div>-->
<!--          <div class="tag tag-write">{{ $t('hero.tagWrite') }}</div>-->
<!--          <div class="tag tag-speak">{{ $t('hero.tagSpeak') }}</div>-->
<!--          <div class="tag tag-read">{{ $t('hero.tagRead') }}</div>-->
<!--          <div class="ai-badge">{{ $t('hero.aiBadge') }}</div>-->
<!--        </div>-->
<!--      </div>-->
    </div>
  </section>
</template>

<script>
export default { name: 'HeroSection' }
</script>

<style scoped>
.hero {
  background: url('../assets/banner@2x.png') center/cover no-repeat;
  padding: 116px 40px 80px;
  position: relative;
  overflow: hidden;
  min-height: 600px;
}
.hero::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: transparent;
}
.hero-content {
  max-width: 1100px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  z-index: 1;
}
.hero-left { flex: 1; padding-top: 100px}
h1 { font-size: 36px; font-weight: 800; color: #1a1a1a; margin-bottom: 8px; line-height: 1.3; }
.highlight { color: #2b7de9; }
.sub { font-size: 16px; color: #666; margin-bottom: 32px; }
.btn-start {
  background: #2b7de9; color: #fff; border: none; padding: 12px 32px;
  border-radius: 6px; font-size: 15px; font-weight: 600; cursor: pointer; transition: background 0.2s;
}
.btn-start:hover { background: #1a6ad4; }
.hero-right { flex: 1; display: flex; justify-content: center; }
.avatar-wrapper { position: relative; }
.avatar {
  width: 200px; height: 240px; background: linear-gradient(135deg, #d2e3fc, #e8f0fe);
  border-radius: 16px; display: flex; align-items: center; justify-content: center; font-size: 100px; overflow: hidden;
}
.avatar-placeholder { line-height: 1; }
.tag { position: absolute; padding: 4px 14px; border-radius: 14px; font-size: 12px; font-weight: 600; color: #fff; white-space: nowrap; }
.tag-write { background: #2b7de9; top: 0; left: -60px; }
.tag-speak { background: #2b7de9; top: 40px; right: -60px; }
.tag-read { background: #2b7de9; bottom: 80px; right: -50px; }
.ai-badge {
  position: absolute; bottom: -10px; left: 50%; transform: translateX(-50%);
  background: linear-gradient(90deg, #2b7de9, #5b9ef5); color: #fff; padding: 8px 24px;
  border-radius: 8px; font-size: 14px; font-weight: 700; letter-spacing: 4px; white-space: nowrap;
}
@media (max-width: 768px) {
  .hero-content { flex-direction: column; gap: 40px; }
  h1 { font-size: 28px; }
  .hero { padding: 40px 20px 60px; }
}
</style>
